import React from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import { useAiLauncher } from "./AiLauncherContext";
import type { AiContext } from "./context";

export const AiLaunchButton: React.VFC<{ context: AiContext; tooltip?: string }> = ({
  context,
  tooltip = "Edit with AI",
}) => {
  const { launch } = useAiLauncher();
  return (
    <Tooltip title={tooltip}>
      <IconButton size="small" onClick={() => launch(context)} style={{ padding: 4 }}>
        <span style={{ fontSize: 16 }}>🤖</span>
      </IconButton>
    </Tooltip>
  );
};
